export const resetPassword = {
  'resetPassword.title': 'Reset your password',
  'resetPassword.description': 'Pick a fresh new password.',
  'resetPassword.buttonResetPassword': 'Reset Password',
  'resetPassword.backToLogIn': 'Back to log in',
  'resetPassword.textLabelNewPass': 'New Password',
  'resetPassword.textLabelConfirmPass': 'Confirm Password',
  'resetPassword.successMessage': 'Your password was successfully changed',
}
